'use client';

import React, { useEffect, useRef } from 'react';
import AppImage from '@/components/ui/AppImage';

/*
BENTO GRID AUDIT:
Array has 5 cards: [Labs, Library, Research, Classrooms, Campus]
Row 1 (12-col): [col 1-5: Labs rs-2] [col 6-9: Library cs-4] [col 10-12: Research cs-3]
Row 2 (12-col): [col 1-5: Labs (cont)] [col 6-9: Classrooms cs-4] [col 10-12: Campus cs-3]
Placed 5/5 cards ✓
Mobile: stack all to single/double col
*/

const items = [
{
  id: 'labs',
  label: 'Research Labs',
  title: 'State-of-the-Art Laboratories',
  image: "/assets/images/chemistry-lab.png",
  alt: 'Modern pharmaceutical laboratory with analytical equipment, clean white benches, bright overhead lighting, professional scientific environment',
  gridClass: 'masonry-item-1'
},
{
  id: 'library',
  label: 'Library',
  title: 'Knowledge Centre',
  image: "/assets/images/Research_lab.jpg",
  alt: 'Modern library with rows of books, reading tables, warm ambient lighting, academic study environment',
  gridClass: 'masonry-item-2'
},
{
  id: 'research',
  label: 'Chemistry Lab',
  title: 'Chemistry Lab',
  image: "/assets/images/lab.jpg",
  alt: 'Scientist conducting pharmaceutical research, close-up of laboratory instruments, clean scientific setting',
  gridClass: 'masonry-item-3'
},
{
  id: 'classrooms',
  label: 'Classrooms',
  title: 'Smart Classrooms',
  image: "/assets/images/corridor.avif",
  alt: 'Modern smart classroom with projector and whiteboards, bright natural light, organised seating for students',
  gridClass: 'masonry-item-4'
},
{
  id: 'campus',
  label: 'Campus',
  title: 'Green Campus',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_18d3c4897-1774988728285.png",
  alt: 'Beautiful college campus with green lawns, trees, and modern academic buildings in clear daylight',
  gridClass: 'masonry-item-5'
}];


export default function CampusHighlights() {
  const gridRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const tiles = entry.target.querySelectorAll<HTMLElement>('.campus-tile');
            tiles.forEach((tile, i) => {
              tile.style.transitionDelay = `${i * 0.1}s`;
              tile.style.opacity = '1';
              tile.style.transform = 'scale(1)';
            });
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );
    if (gridRef?.current) observer?.observe(gridRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section data-component-id="src/app/components/CampusHighlights.tsx:83:4" data-component-path="src/app/components/CampusHighlights.tsx" data-component-line="83" data-component-end-line="122" data-component-file="CampusHighlights.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-20%20md%3Apy-28%20px-6%20max-w-7xl%20mx-auto%22%7D" className="py-20 md:py-28 px-6 max-w-7xl mx-auto">
      <div data-component-id="src/app/components/CampusHighlights.tsx:84:6" data-component-path="src/app/components/CampusHighlights.tsx" data-component-line="84" data-component-end-line="90" data-component-file="CampusHighlights.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-12%22%7D" className="mb-12">
        <span data-component-id="src/app/components/CampusHighlights.tsx:85:8" data-component-path="src/app/components/CampusHighlights.tsx" data-component-line="85" data-component-end-line="85" data-component-file="CampusHighlights.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22section-label%20block%20mb-3%22%2C%22textContent%22%3A%22Campus%20Life%22%7D" className="section-label block mb-3">Campus Life</span>
        <h2 data-component-id="src/app/components/CampusHighlights.tsx:86:8" data-component-path="src/app/components/CampusHighlights.tsx" data-component-line="86" data-component-end-line="89" data-component-file="CampusHighlights.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-display%20text-foreground%22%2C%22textContent%22%3A%22Spaces%20That%22%7D" className="text-display text-foreground">
          Spaces That{' '}
          <em data-component-id="src/app/components/CampusHighlights.tsx:88:10" data-component-path="src/app/components/CampusHighlights.tsx" data-component-line="88" data-component-end-line="88" data-component-file="CampusHighlights.tsx" data-component-name="em" data-component-content="%7B%22elementName%22%3A%22em%22%2C%22className%22%3A%22font-normal%20italic%20text-primary%22%2C%22textContent%22%3A%22Inspire%22%7D" className="font-normal italic text-primary">Inspire</em>
        </h2>
      </div>
      <div data-component-id="src/app/components/CampusHighlights.tsx:91:6" data-component-path="src/app/components/CampusHighlights.tsx" data-component-line="91" data-component-end-line="121" data-component-file="CampusHighlights.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22masonry-grid%22%7D" ref={gridRef} className="masonry-grid" style={{ minHeight: '500px' }}>
        {items?.map((item) =>
        <div data-component-id="src/app/components/CampusHighlights.tsx:93:8" data-component-path="src/app/components/CampusHighlights.tsx" data-component-line="93" data-component-end-line="119" data-component-file="CampusHighlights.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
          key={item?.id}
          className={`campus-tile ${item?.gridClass} relative overflow-hidden rounded-xl group cursor-pointer`}
          style={{
            opacity: 0,
            transform: 'scale(0.96)',
            transition: 'opacity 0.8s cubic-bezier(0.16,1,0.3,1), transform 0.8s cubic-bezier(0.16,1,0.3,1)',
            minHeight: item?.id === 'labs' ? '400px' : '190px'
          }}>
          
            <AppImage data-component-id="src/app/components/CampusHighlights.tsx:103:12" data-component-path="src/app/components/CampusHighlights.tsx" data-component-line="103" data-component-end-line="108" data-component-file="CampusHighlights.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22className%22%3A%22object-cover%20transition-transform%20duration-700%20group-hover%3Ascale-105%22%7D"
            src={item?.image}
            alt={item?.alt}
            fill
            className="object-cover transition-transform duration-700 group-hover:scale-105"
            sizes="(max-width: 768px) 100vw, 40vw" />
          
            {/* Overlay */}
            <div data-component-id="src/app/components/CampusHighlights.tsx:111:12" data-component-path="src/app/components/CampusHighlights.tsx" data-component-line="111" data-component-end-line="111" data-component-file="CampusHighlights.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-gradient-to-t%20from-black%2F60%20via-transparent%20to-transparent%20opacity-0%20group-hover%3Aopacity-100%20transition-opacity%20duration-500%22%7D" className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            {/* Label */}
            <div data-component-id="src/app/components/CampusHighlights.tsx:113:12" data-component-path="src/app/components/CampusHighlights.tsx" data-component-line="113" data-component-end-line="118" data-component-file="CampusHighlights.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20bottom-0%20left-0%20right-0%20p-4%20translate-y-4%20opacity-0%20group-hover%3Atranslate-y-0%20group-hover%3Aopacity-100%20transition-all%20duration-500%22%7D" className="absolute bottom-0 left-0 right-0 p-4 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
              <span data-component-id="src/app/components/CampusHighlights.tsx:114:14" data-component-path="src/app/components/CampusHighlights.tsx" data-component-line="114" data-component-end-line="116" data-component-file="CampusHighlights.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-xs%20font-semibold%20text-white%2F70%20uppercase%20tracking-widest%20block%22%7D" className="text-xs font-semibold text-white/70 uppercase tracking-widest block">
                {item?.label}
              </span>
              <p data-component-id="src/app/components/CampusHighlights.tsx:117:14" data-component-path="src/app/components/CampusHighlights.tsx" data-component-line="117" data-component-end-line="117" data-component-file="CampusHighlights.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20font-semibold%20text-sm%20mt-0.5%22%7D" className="text-white font-semibold text-sm mt-0.5">{item?.title}</p>
            </div>
          </div>
        )}
      </div>
    </section>);

}